<template>
    <div class="box branding">
        <h2 class="box-title">
            Branding
        </h2>
        <div class="box-content">
            <form
                id="branding"
                novalidate
                @submit.prevent="saveInfo"
            >
                <div
                    v-if="hasColors"
                    class="field is-centered flex"
                    :class="{ free: ! hasColors }"
                >
                    <span class="field-title">Brand Color:</span>
                    <base-color-picker
                        :color="config.color"
                        class="is-small"
                        :disabled="! hasColors"
                        @change="value => {
                            changeColor(value)
                        }"
                    />
                    <a
                        href="#"
                        :class="[{ active: showEmbed }, 'show-embed', 'cancel-link']"
                        @click.prevent="showEmbed = ! showEmbed"
                    >
                        <template v-if="showEmbed">
                            Hide player preview
                        </template>
                        <template v-else>
                            Show player preview
                        </template>
                        <i class="fas fa-chevron-right" />
                    </a>
                </div>
                <base-settings-row
                    v-else
                    input-type="radio"
                    config-title="Brand Color"
                    :fields-config="freePlayerColorsConfig"
                    :binded-value="config.color"
                    settings-key="color"
                    class="is-centered without-border"
                    :input-class="['is-round']"
                    @change="({ color }) => changeColor(color)"
                />
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <div
                        v-if="hasColors && showEmbed"
                        class="player-embed"
                        @click.prevent=""
                    >
                        <base-loader v-if="!player" />
                        <player-embed-script
                            :id="show.lastEpisodeNumber"
                            :key="show.hash"
                            :hash="show.hash"
                            :player-type="show.lastEpisodeNumber ? 'track' : 'custom'"
                        />
                    </div>
                </transition>

                <div class="controll-container flex">
                    <base-form-button
                        class="btn"
                        :loading="formProcessing"
                    >
                        Save Changes
                    </base-form-button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { isEqual } from 'lodash';
import PlayerEmbedScript from '@/components/PlayerEmbedScript';
import playerSettings from '@/utils/config/playerSettings';
import { Feature, hasFeature } from '@/utils/show';
import BaseSettingsRow from '../../BaseSettingsRow';
import { mapState } from 'vuex';

const { freePlayerColorsConfig } = playerSettings;

export default {
    components: {
        PlayerEmbedScript,
        BaseSettingsRow,
    },

    props: {
        show: {
            type: Object,
            default: () => ({}),
        },
        formProcessing: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        config: {
            color: null,
        },
        showEmbed: false,
        freePlayerColorsConfig,
        player: false,
    }),

    computed: {
        ...mapState(['user']),

        /**
         * Checks if the show has color customization feature enabled.
         *
         * @returns {boolean} True if the show has color customization feature.
         */
        hasColors() {
            return hasFeature(this.show, Feature.ColorCustomization);
        },

        /**
         * Gets the default config of player.
         *
         * @returns {object} Default player config.
         */
        defaultPlayerConfig() {
            return {
                buttonConfig: {},
                buttons: this.show.buttons,
                color: this.show.color,
                controls: this.show.controls,
                cover: this.show.cover,
                coverDisplay: this.show.coverDisplay,
                credits: false,
                position: 'bottom',
                sticky: false,
                style: 'regular',
                title: this.show.title,
                tracks: [{
                    description: 'Description goes here',
                    duration: 1234,
                    episodeNo: 1,
                    featured: false,
                    file: '',
                    title: 'Title goes here',
                }],
            };
        },
    },

    watch: {
        show: {
            immediate: true,

            /**
             * Manage data.
             *
             * @param {object} show Show object data.
             * @param {*} oldShow Show object data.
             */
            handler(show, oldShow) {
                if (isEqual(show, oldShow)) {
                    return;
                }

                this.config.color = show.color || '#06B059';
            },
        },
    },

    /**
     * Created hook
     */
    created() {
        window.FuseboxPlayerAPIKey = this.show.token;

        window.addEventListener('loadFuseboxPlayer', this.loadDefaultData);
    },

    /**
     * Handles component destroy.
     */
    destroyed() {
        window.removeEventListener('loadFuseboxPlayer', this.loadDefaultData);
    },

    methods: {
        /**
         * Loads default player data.
         *
         * @param  {Event} e Event.
         */
        loadDefaultData(e) {
            this.player = window.fuseboxPlayer(e.detail);

            if (! this.show.lastEpisodeNumber) {
                this.player.setConfig(this.defaultPlayerConfig);
            }
        },

        /**
         *
         * @param {string} color color
         * @returns {void} changes the color of player
         */
        changeColor(color) {
            this.config.color = color;
            if (this.player) {
                this.player.setColor(this.config.color);
            }
        },

        /**
         * Submit form
         *
         * @returns {void} Do nothing, now.
         */
        saveInfo() {
            if (! this.validate() || this.formProcessing) {
                return;
            }

            this.$emit('submit', this.config);
        },

        /**
         * Valdiate form and set errors
         *
         * @returns {boolean} If validation is passed
         */
        validate() {
            return true;
        },
    },
};
</script>
